<template>
  <div class="tranche-update-class-a-type-container">
    <b-form-checkbox :id="getId()"
                     class="tranche-update-class-a-type"
                     @change="patchClassA($event)"
                     v-model="classA">
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'TrancheUpdateClassAType',
  props: {
    trancheUpdate: { type: Object, required: true },
  },
  data() {
    return {
      classA: false,
    };
  },
  methods: {
    getId() {
      return `tranche-update-class-a-type-${this._uid}`;
    },
    patchClassA(event) {
      this.classA = event;
      this.$store.commit('setGlobalSpinnerShow', true);
      // Prepare data
      const data = {
        form: { classA: this.classA },
        id: this.trancheUpdate.id,
      };
      this.$store.dispatch('patchTrancheUpdate', data)
        .then(() => {
          // Show success toast
          const toast = {
            show: true,
            message: 'Mise à jour effectuée !',
            variant: 'success',
            duration: 1000,
          };
          this.$store.commit('setGlobalToaster', toast);
          this.$emit('classAUpdated', this.trancheUpdate.classA);
        }, (error) => {
          console.log('Patch trancheUpdate classA error : ', error);
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
        });
    },
  },
  beforeMount() {
    this.classA = this.trancheUpdate.classA;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .tranche-update-class-a-type-container{
    display: flex;
    align-items: center;
    padding-left: 4px;
    background-color: white;
    height: 24px;
    width: 24px;
    border-radius: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/TrancheUpdateClassAType.vue